// metadata/resolve.ts
import { baseqlMetaData } from "./metaDataStore.js";
import { BaseQLUnion } from "./union.js";
var getAllFieldDefinitions = (input) => {
  if (input instanceof BaseQLUnion || typeof input === "function" && !("_class" in input)) {
    const type = typeof input === "function" ? input() : input;
    if (type instanceof BaseQLUnion || input instanceof BaseQLUnion) {
      const unionDefinition = baseqlMetaData.unions[type._class];
      if (!unionDefinition)
        throw new Error(`Could not find unionDefinition to union with name ${type._class}`);
      return unionDefinition.types().flatMap((unionMember) => getAllFieldDefinitions(unionMember));
    }
  }
  const resolvedNode = baseqlMetaData.entities.resolveNode(input);
  return baseqlMetaData.entities.reduce(
    (acc, node, depth) => {
      const fields = depth ? Object.values(node.fields).filter((field) => !field.fromParent) : Object.values(node.fields);
      return acc.concat(fields);
    },
    [],
    resolvedNode
  );
};
var normalizePath = (input) => {
  if (!Array.isArray(input))
    input = [input];
  return input.flatMap((part) => part.split("."));
};
var resolveFieldDefinition = (input, path) => {
  path = normalizePath(path);
  if (!path.length)
    throw new Error("Cannot resolve field definition without path");
  let fields = getAllFieldDefinitions(input);
  while (path.length > 1) {
    const fieldName2 = path.shift();
    const field2 = fields.find((f) => f.name === fieldName2);
    if (!field2)
      throw new Error(`could not resolve field "${fieldName2}"`);
    fields = getAllFieldDefinitions(field2.type);
  }
  const fieldName = path.shift();
  const field = fields.find((f) => f.name === fieldName);
  if (!field)
    throw new Error(`could not resolve field "${fieldName}"`);
  return field;
};
export {
  getAllFieldDefinitions,
  resolveFieldDefinition
};
